// extracted by mini-css-extract-plugin
export default {"table":"withdrawals_table__0nuz3","verticalFiller":"withdrawals_verticalFiller__Sw0+a"};